// 生成路由
// import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import { loginUrl } from './config/env'
import { MessageBox } from 'element-ui'
import { getMenus } from '@/api/login'
router.beforeEach((to, from, next) => {
  // console.log(to)
  // 根据字段判断是否进行路由过滤（即是否需要登录才能访问）
  if (to.meta.ignore) {
    next()
  } else {
    // next()
    let roles = store.getters.permissionList || (sessionStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : [])
    if (roles && roles.length > 0) {
      // console.log('auth11', store.getters.addRouters)
      if (store.getters.addRouters === null || store.getters.addRouters.length === 0) {
        store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          let routeList = store.getters.addRouters
          // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          if (isHanveRoute(routeList, to.path)) {
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          } else {
            loginNoToken()
          }
        })
      } else {
        // store.dispatch('setUserToken', Cookies.get('USER_TOKEN') || '')
        next()
      }
    } else {
      if (to.path == '/screen') {
        getMenusInfo(to, next)
      } else {
        loginNoToken()
      }
    }
  }
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})
// 判断是否有此权限
function isHanveRoute (list, path) {
  let flag = false
  if (path === '/screen') {
    let flag1 = list.some(val => val.path == path)
    if (flag1) {
      flag = true
    }
  } else {
    list.forEach(item => {
      if (item.children && item.children.length > 0) {
        let flag2 = item.children.some(val => item.path + '/' + val.path == path)
        if (flag2) {
          flag = true
        }
      }
    })
  }
  return flag
}
// 登录失效
function loginNoToken () {
  MessageBox.alert('登录失效，请重新登录！', '提示', {
    confirmButtonText: '重新登录',
    type: 'warning',
    callback: action => {
      window.location.href = loginUrl
    }
  })
}

async function getMenusInfo (to, next) {
  let resData = await getMenus()
  sessionStorage.removeItem('auth')
  if (resData) {
    let roles = resData || []
    sessionStorage.setItem('auth', JSON.stringify(roles))
    store.dispatch('setPermissionList', roles)
    store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
      router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
      if (roles.includes('screen') || roles.includes('company_manager')) {
        if (to.query && to.query.type) {
          router.push({
            path: '/screen',
            query: {
              type: 1
            }
          })
        } else {
          router.push({
            path: '/screen'
          })
        }
      } else {
        loginNoToken()
      }
    })
  }
}
